import { render } from "./PanelManager.vue?vue&type=template&id=34114c16"
import script from "./PanelManager.vue?vue&type=script&lang=js"
export * from "./PanelManager.vue?vue&type=script&lang=js"

import "./PanelManager.vue?vue&type=style&index=0&id=34114c16&lang=css"

import exportComponent from "/mnt/projects/panel.doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__